// extracted by mini-css-extract-plugin
module.exports = {"slideIn":"_2lF930"};